module.exports = "/build/images/contract.png?dbf7a58e8fca62d95a65536492d2945e";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/contract.png
// module id = 2775
// module chunks = 0